<template>
  <div class="staff-calendar">
    <h4
      v-if="list.length > 0"
      class="mt-4"
    >
      <slot name="title" />
    </h4>
    <InfinityScrollTripTable
      :endpoint="endpoint"
      row-links
      @update="update"
    >
      <template #noneFoundMessage>
        <span data-i18n="tourleader.departures.none">
          {{ $t('tourleader.departures.none') }}
        </span>
      </template>
    </InfinityScrollTripTable>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    id: {
      type: String,
      default: null,
    },
  },

  emits: ['update'],

  data () {
    return {
      list: [],
    }
  },

  computed: {
    endpoint () {
      return `calendar?staffid=${this.id}`
    },
  },

  methods: {
    update (data) {
      this.list = data?.departures || []
      this.$emit('update', data)
    },
  },
})
</script>
